export default "__VITE_ASSET__DDkM0Q9d__"